import { useBoundStore } from "@/app/store";
import { ToolbarEdit } from "@/features/notes/components/Editor/components/ToolbarEdit";
import { ToolbarPreview } from "@/features/notes/components/Editor/components/ToolbarPreview";
import { useShallow } from "zustand/shallow";

export function EditToolbarStep() {
  const { userId, toolbarItems, updateSettings } = useBoundStore(
    useShallow((state) => ({
      userId: state.user.id,
      toolbarItems: state.settings.notes.editorToolbarItems,
      updateSettings: state.settings.updateSettings,
    }))
  );
  const deviceType = useBoundStore(useShallow((state) => state.device.type));
  const isMobile = deviceType === "mobile";

  const handleToggle = (itemId: string) => {
    const updated = toolbarItems.map((item) => (item.id === itemId ? { ...item, enabled: !item.enabled } : item));

    // Update settings with new enabled items
    if (userId) {
      updateSettings(userId, {
        notes: { ...useBoundStore.getState().settings.notes, editorToolbarItems: updated },
      });
    }
  };

  const handleReorder = (reorderedItems: typeof toolbarItems) => {
    // Update settings with new order
    if (userId) {
      updateSettings(userId, {
        notes: { ...useBoundStore.getState().settings.notes, editorToolbarItems: reorderedItems },
      });
    }
  };

  return (
    <div className="flex h-full flex-col justify-between gap-3 overflow-hidden">
      <div className="flex-1 min-h-0 overflow-y-auto">
        <ToolbarEdit items={toolbarItems} onToggle={handleToggle} onReorder={handleReorder} isMobile={isMobile} />
      </div>
      <div className="flex-shrink-0">
        <ToolbarPreview items={toolbarItems} />
      </div>
    </div>
  );
}
